import React, {Component} from 'react';

import {appStore} from '../../stores/AppStore';



export default data => [
    {label: 'Notes 1', key: 'notes', type: 'textarea', defaultValue: data.notes, disabled: false},
    {label: 'Notes 2', key: 'note1', type: 'textarea', defaultValue: data.note1, disabled: false},
    {label: 'Notes 3', key: 'note2', type: 'textarea', defaultValue: data.note2, disabled: false},
    {
            key: "globalWorkflowId",
            label: "Workflow",
            type: "dropdown",
            options: appStore.getWorkFlow,
            defaultValue:data.globalWorkflowId,
            disabled: false,
    },
    {label: 'CTP', key: 'ctp', type: 'text', defaultValue: data.ctp, disabled: false},

    {label: 'Review Type', key: 'reviewType', type: 'text', defaultValue: data.reviewType, disabled: false},
    {
        label: 'Pre Review',
        key: 'preReview',
        type: 'binary_dropdown',
        defaultValue: data.preReview,
        disabled: false,
    }, {
        label: 'P1 Status',
        key: 'p1Status',
        type: 'binary_dropdown',
        defaultValue: data.p1Status,
        disabled: false,
    },
    {
        label: 'Category',
        key: 'category',
        type: 'number',
        defaultValue: data.category
    },
    {
        label: 'Grade',
        key: 'grade',
        type: 'text',
        defaultValue: data.grade
    }, {
        label: 'Last Supplement',
        key: 'lastSupplement',
        type: 'number',
        defaultValue: data.lastSupplement
    },
    {
        label: 'Do Not start',
        key: 'doNotChase',
        type: 'binary_dropdown',
        defaultValue: data.doNotChase
    },
    {
        label: 'Do Not Chase',
        key: '',
        type: 'binary_dropdown',
        defaultValue:'',
       
    },
   // {label: 'Editor Emails', key: 'editorEmails', type: 'text', defaultValue: data.editorEmails, disabled: false},
    {
        label: 'Last Updated Date',
        key: 'lastUpdatedDate',
        type: 'date',
        defaultValue: data.lastUpdatedDate
    },
    {
        label: 'Last Published',
        key: 'lastPublishedDate',
        type: 'date',
        defaultValue: data.lastPublishedDate,
       
    },  
    {
        label: 'Expected Project Start Date',
        key: 'projectStartDate',
        type: 'date',
        defaultValue: data.projectStartDate
    }, {
        label: 'Ifp Date',
        key: 'ifpDate',
        type: 'date',
        defaultValue: data.ifpDate
    }, {
        label: 'Cmp Date',
        key: 'cmpDate',
        type: 'date',
        defaultValue: data.cmpDate
     },
    // {
    //     label: 'Files To Author Date',
    //     key: 'filesToAuthorDate',
    //     type: 'date',
    //     defaultValue: data.filesToAuthorDate
    // }, {
    //     label: 'Files From Author Date',
    //     key: 'filesFromAuthorDate',
    //     type: 'date',
    //     defaultValue: data.filesFromAuthorDate
    // },
     {
        label: 'Heads Up Email Date',
        key: 'headsUpEmailDate',
        type: 'date',
        defaultValue: data.headsUpEmailDate
    },
    {label: 'Author Query', key: 'authorQuery', type: 'textarea', defaultValue: data.authorQuery},
    {label: 'Files Sent', key: 'filesSent', type: 'number', defaultValue: data.filesSent},
    {label: 'Files Received', key: 'filesReceived', type: 'number', defaultValue: data.filesReceived},
    {label: 'Author Comments', key: 'comments', type: 'plaintext', defaultValue: data.comments, disabled: true},
]

